<template>
<div class="grid">
  <tile v-for="tile in tiles" :key="tile">
  </tile>
</div>

</template>

<script>
import Tile from '@/components/utils/tiles/Tile';

export default {
  name: 'GridPlay',
  data() {
    return {
      tiles: [...Array(20).keys()],
    };
  },
  components: {
    Tile,
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 2rem;
}

.grid::before {
  content: '';
  width: 0;
  padding-bottom: 100%;
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.grid > *:first-child {
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

</style>
